"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPIN_DISPLAY = void 0;
exports.default = SpinResults;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("@site/utils");
var _uxUtils = require("@site/ux-utils");
var _buttons = require("@site/buttons");
var _SpinDomain = _interopRequireDefault(require("./SpinDomain"));
var _SpinAddToCartButton = _interopRequireDefault(require("./SpinAddToCartButton"));
var _SpinAuctionRedirectButton = _interopRequireDefault(require("./SpinAuctionRedirectButton"));
var _priceBlock = require("@site/price-block");
var _Tags = require("./Tags");
var _ProductContent = _interopRequireDefault(require("./ProductContent"));
var _EidCodes = _interopRequireDefault(require("../EidCodes"));
var _SpinRtb = _interopRequireDefault(require("./SpinRtb"));
var _domainServices = require("@site/domain-services");
var _sharedComponents = require("@site/shared-components");
var _refresh = _interopRequireDefault(require("@ux/icon/refresh"));
var _lightbulb = _interopRequireDefault(require("@ux/icon/lightbulb"));
var _favoritesButton = require("@site/favorites-button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const cartStateToCtaStateMap = {
  [_buttons.CART_STATE.BEFORE_ADD_TO_CART]: _buttons.CTA_STATUS.RUNNING,
  [_buttons.CART_STATE.ADD_TO_CART_SUCCESS]: _buttons.CTA_STATUS.COMPLETE,
  [_buttons.CART_STATE.ADD_TO_CART_FAILURE]: _buttons.CTA_STATUS.FAILED,
  [_buttons.CART_STATE.ADD_TO_CART_UNAVAILABLE]: _buttons.CTA_STATUS.FAILED,
  [_buttons.CART_STATE.BEFORE_REMOVE_FROM_CART]: _buttons.CTA_STATUS.COMPLETE,
  [_buttons.CART_STATE.REMOVE_FROM_CART_SUCCESS]: _buttons.CTA_STATUS.PENDING,
  [_buttons.CART_STATE.REMOVE_FROM_CART_FAILURE]: _buttons.CTA_STATUS.FAILED
};
const dopTypeMap = {
  DOP: 'basic',
  DOPC: 'dopclone',
  DOPL: 'doplite'
};
const SPIN_DISPLAY = exports.SPIN_DISPLAY = {
  SLAT: 'SLAT',
  CARD: 'CARD'
};
function SpinResults({
  dataCy,
  domainEntry,
  customDomainInfo,
  customAddToCartButton,
  CustomCartStateBadge,
  customPriceBlock,
  product,
  dataEid,
  openButton,
  handleShowMoreLikeThisClick,
  showMoreLikeThisOption,
  showMoreLikeThisDomains,
  isDomainInCart = false,
  options = {},
  ctaProps = {},
  enableDynamicFontScaling = false,
  language = {},
  display = SPIN_DISPLAY.SLAT,
  SpinDomainIcon,
  auctionTypeIdsStraightToCart = [],
  dbsPrice = '',
  customHeroImage
}) {
  const {
    isMobile,
    isTablet
  } = (0, _uxUtils.useDeviceType)();
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const [cartState, setCartState] = (0, _react.useState)(isDomainInCart ? _buttons.CTA_STATUS.COMPLETE : _buttons.CTA_STATUS.PENDING);
  const domain = {
    Inventory: domainEntry.Inventory,
    IsPremiumTier: domainEntry.IsPremiumTier,
    AvailabilityLabel: domainEntry.AvailabilityLabel
  };
  const isPremiumDomain = (0, _utils.renderAsPremium)(domain);
  const isAuctionDomain = (0, _utils.isAuction)(domain);
  const isTakenDomain = (0, _utils.isTaken)(domain);
  const isAftermarketPremiumDomain = (0, _utils.isAftermarketPremium)(domain);
  const auctionEndTime = domainEntry?.AuctionEndTime;
  const isCountdownTimerEnabled = domainEntry?.isCountdownTimerEnabled;
  const showAuctionCountdownTimer = isAuctionDomain && auctionEndTime && isCountdownTimerEnabled;
  const hasProductContent = !!product?.Content?.Messages;
  const {
    Fqdn,
    Extension,
    NameWithoutExtension,
    IsRecommended,
    IsAd,
    IsExactMatch,
    rtbs,
    Inventory,
    AuctionTypeId,
    AuctionId,
    IsDbsAvailable,
    LeaseToOwnOptions = {}
  } = domainEntry;
  const {
    enableHover = false,
    displayPercentagePrice = false,
    enableFavorites: favoritesOn,
    tagsAndInfo = {},
    showPricing = true,
    showDBS = true,
    styleOverrides: {
      sldStyle = {},
      tldStyle = {},
      premiumTldStyle = {},
      pricingStyleOverrides = {},
      premiumTagStyle = {}
    } = {},
    market = 'en-US',
    privateLabelId = 1,
    env,
    itc,
    isc,
    apiKey,
    isListPricePriority = false,
    hideListPrice = false,
    showFreeIndicator = false,
    showSpinsRtbs = false,
    spinsRtbPosition = 'bottom',
    autoAddDopOptions = {},
    customAddToCartTerms,
    showLto,
    favoritesIcons = {
      icon: 'heart',
      filledIcon: 'heart-filled'
    }
  } = options;
  const isCard = display === SPIN_DISPLAY.CARD;
  const isLtoSpin = showLto && Object.keys(LeaseToOwnOptions).length > 0;
  const regularPricingUnavailable = isTakenDomain && (!IsDbsAvailable || !showDBS) || isLtoSpin;
  const spinPriceOptions = {
    displayPercentagePrice,
    classNames: {
      ...pricingStyleOverrides
    },
    isListPricePriority,
    hideListPrice,
    showFreeIndicator,
    tooltipButtonAriaLabel: formatMessage({
      id: 'ariaLabelOpenPricingTooltip'
    }, {
      product: Fqdn
    })
  };
  const rtb = showSpinsRtbs && rtbs?.[0]?.reason;
  const tagsProps = {
    domainExtension: Extension,
    isRecommended: IsRecommended,
    isAd: IsAd,
    isExactMatch: IsExactMatch,
    isPremium: isPremiumDomain,
    isAuction: isAuctionDomain,
    isAftermarketPremium: isAftermarketPremiumDomain,
    inventory: Inventory,
    isMobile,
    tagsAndInfo: {
      ...tagsAndInfo,
      ...(rtb && {
        rtb,
        spinsRtbPosition
      })
    },
    market
  };
  const onCartStateChange = data => {
    if (data?.state) {
      setCartState(cartStateToCtaStateMap[data.state]);
    }
  };
  const AddToCardButton = () => {
    const {
      showMakeOffer,
      makeOfferTextId
    } = (0, _utils.getAuctionInfo)(AuctionTypeId, auctionTypeIdsStraightToCart);
    const dopType = autoAddDopOptions.supportedTlds?.includes(Extension) && dopTypeMap[autoAddDopOptions.dopType];
    if (customAddToCartButton) {
      return /*#__PURE__*/_react.default.cloneElement(customAddToCartButton, {
        onCartStateChange,
        ...(isCard && {
          customClassNames: 'spin-card-buy-button px-card-content pt-3'
        })
      });
    } else if (isAuctionDomain && showMakeOffer) {
      const domainServices = (0, _domainServices.initializeDomainServices)({
        env,
        apiKey,
        plid: privateLabelId,
        market
      });
      const auctionUrl = `${domainServices.auctionsHost}?src=dpp&miid=${AuctionId}&itc=${itc}&isc=${isc}`;
      return /*#__PURE__*/_react.default.createElement(_SpinAuctionRedirectButton.default, {
        fqdn: Fqdn,
        makeOfferTextId: makeOfferTextId,
        auctionUrl: auctionUrl
      });
    } else if (isTakenDomain && (!IsDbsAvailable || !showDBS)) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        'spin-card-buy-button px-card-content pt-3': isCard
      })
    }, /*#__PURE__*/_react.default.createElement(_SpinAddToCartButton.default, (0, _extends2.default)({
      domain: domainEntry,
      product,
      openButton,
      onCartStateChange,
      productWithSapiOverrides: isTakenDomain ? {
        packageIdOverride: 'dbs'
      } : {},
      productsInCart: isDomainInCart,
      dopType,
      customAddToCartTerms
    }, ctaProps)));
  };
  const PriceBlockComponent = () => {
    if (CustomCartStateBadge && cartState !== _buttons.CTA_STATUS.PENDING) return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        'mr-2': isTablet
      })
    }, /*#__PURE__*/_react.default.createElement(CustomCartStateBadge, {
      cartState: cartState,
      isCard: isCard
    }));else if (showPricing && isTakenDomain && IsDbsAvailable) return customPriceBlock || /*#__PURE__*/_react.default.createElement(_priceBlock.DbsPriceBlock, {
      domain: domainEntry,
      options: spinPriceOptions,
      language,
      plid: privateLabelId,
      dbsPrice,
      customHeroImage
    });else if (regularPricingUnavailable) return null;else if (showPricing) return customPriceBlock || /*#__PURE__*/_react.default.createElement(_priceBlock.StandardPriceBlock, {
      domain: domainEntry,
      product,
      options: spinPriceOptions,
      enableDynamicFontScaling,
      language
    });
  };
  const DomainInfo = () => {
    if (customDomainInfo) {
      return customDomainInfo;
    } else if (isTakenDomain) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)({
          'd-inline-flex flex-grow-1 align-items-center': !isMobile
        })
      }, !isMobile && IsDbsAvailable && showDBS && /*#__PURE__*/_react.default.createElement(_sharedComponents.HeroIcon, {
        border: true,
        height: 56,
        width: 56,
        customImage: customHeroImage
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('d-flex flex-column justify-content-center', {
          'ml-3': !isMobile
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "domain-name"
      }, /*#__PURE__*/_react.default.createElement("h4", {
        className: (0, _classnames.default)('d-inline', {
          ms1: isMobile
        })
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "text-muted"
      }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: "domainIsTaken",
        values: {
          domain: Fqdn
        }
      })))), IsDbsAvailable && showDBS && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)({
          'ms-2': isMobile
        })
      }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: "dbsRtb"
      }), "\xA0")));
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "spin-domain-outer-div d-inline-flex flex-grow-1 flex-column justify-content-center"
    }, /*#__PURE__*/_react.default.createElement(_Tags.Tags, (0, _extends2.default)({}, tagsProps, {
      premiumTagStyle
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('spin-domain-span overflow-wrap text-break lh-reset', {
        'spin-domain-span-dynamic-font-scaling': enableDynamicFontScaling,
        'd-flex align-items-center pb-1': isCard
      })
    }, SpinDomainIcon && /*#__PURE__*/_react.default.createElement("span", {
      className: "mr-2 d-flex"
    }, /*#__PURE__*/_react.default.createElement(SpinDomainIcon, null)), /*#__PURE__*/_react.default.createElement(_SpinDomain.default, {
      isMobile,
      isPremium: isPremiumDomain,
      Fqdn,
      Extension,
      NameWithoutExtension,
      sldStyle,
      tldStyle,
      premiumTldStyle,
      enableDynamicFontScaling,
      fontSize: isCard ? {
        desktop: 'ms2'
      } : {}
    }), showMoreLikeThisOption && !isCard && !isDomainInCart && /*#__PURE__*/_react.default.createElement("button", {
      onClick: handleShowMoreLikeThisClick,
      "data-cy": "spins-more-like-this-option",
      "data-testid": "spins-more-like-this-option",
      className: (0, _classnames.default)('ml-4 spin-view-more-tag', {
        'd-inline-block': openButton
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex align-items-center"
    }, showMoreLikeThisDomains ? /*#__PURE__*/_react.default.createElement(_lightbulb.default, {
      width: 16,
      height: 16
    }) : /*#__PURE__*/_react.default.createElement(_refresh.default, {
      width: 16,
      height: 16
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-1 ms-3"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: showMoreLikeThisDomains ? 'aboutThisName' : 'moreLikeThis'
    })))), hasProductContent && /*#__PURE__*/_react.default.createElement(_ProductContent.default, {
      product,
      isMobile
    }))), rtb && spinsRtbPosition === 'bottom' && /*#__PURE__*/_react.default.createElement(_SpinRtb.default, {
      rtb: rtb,
      classNames: "text-black font-weight-normal ms-2 mt-1"
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styled-spins-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    key: market,
    messages: language
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex justify-content-around modernize-spin align-items-center px-0 min-h-8', {
      'flex-column h-100': isCard,
      enableHover
    }),
    "data-cy": dataCy
  }, favoritesOn && /*#__PURE__*/_react.default.createElement(_favoritesButton.FavoritesButton, {
    classNames: (0, _classnames.default)('spin-left-icon', {
      'align-self-end': isCard
    }),
    dataEid: dataEid || _EidCodes.default.Domain.Spins,
    domain: domainEntry,
    showLabel: false,
    favoritesIcons: favoritesIcons
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": `spin-domain-info${isPremiumDomain ? `-${domainEntry.Inventory}` : ''}`,
    "data-testid": `spin-domain-info${isPremiumDomain ? `-${domainEntry.Inventory}` : ''}`,
    className: (0, _classnames.default)('d-inline-flex spins-domain-info', {
      'pl-1': !isMobile,
      'pr-1': !isMobile && !isLtoSpin,
      'pr-2 flex-grow-1 flex-column': isMobile,
      'pl-2': favoritesOn && isMobile,
      'spin-content': favoritesOn,
      'py-2': !isCard,
      'flex-column px-card-content': isCard,
      'align-items-center': isLtoSpin && !isMobile,
      'align-items-start': isLtoSpin && isMobile
    })
  }, /*#__PURE__*/_react.default.createElement(DomainInfo, null), /*#__PURE__*/_react.default.createElement(PriceBlockComponent, null), showAuctionCountdownTimer && /*#__PURE__*/_react.default.createElement(_sharedComponents.CountdownTimer, {
    targetDate: auctionEndTime
  }), isLtoSpin && AddToCardButton()), !isLtoSpin && AddToCardButton())));
}
const ctaPropsPropTypes = {
  ..._SpinAddToCartButton.default.propTypes
};
delete ctaPropsPropTypes.product;
SpinResults.propTypes = {
  language: _propTypes.default.object.isRequired,
  domainEntry: _propTypes.default.object.isRequired,
  dataCy: _propTypes.default.string.isRequired,
  dataEid: _propTypes.default.string,
  product: _propTypes.default.object.isRequired,
  customDomainInfo: _propTypes.default.object,
  customAddToCartButton: _propTypes.default.object,
  CustomCartStateBadge: _propTypes.default.func,
  customPriceBlock: _propTypes.default.object,
  options: _propTypes.default.object,
  useSelector: _propTypes.default.func,
  ctaProps: _propTypes.default.shape(ctaPropsPropTypes),
  enableDynamicFontScaling: _propTypes.default.bool,
  openButton: _propTypes.default.bool,
  isDomainInCart: _propTypes.default.bool,
  display: _propTypes.default.string,
  SpinDomainIcon: _propTypes.default.func,
  auctionTypeIdsStraightToCart: _propTypes.default.array,
  dbsPrice: _propTypes.default.string,
  handleShowMoreLikeThisClick: _propTypes.default.func,
  showMoreLikeThisOption: _propTypes.default.bool,
  showMoreLikeThisDomains: _propTypes.default.bool,
  customHeroImage: _propTypes.default.string
};